var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCptl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.273,
    height: 45,
    viewBox: "0 0 49.273 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CPTL",
    transform: "translate(-105.055 -56.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M304.4,66.457c6.711-.214,6.71-9.944,0-10.157C297.688,56.514,297.689,66.245,304.4,66.457Z",
    transform: "translate(-174.707)",
    fill: "#f26222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M274.262,168.392H287.75a.882.882,0,0,0,.844-1.1,7.876,7.876,0,0,0-15.166,0,.873.873,0,0,0,.835,1.1Z",
    transform: "translate(-151.319 -94.632)",
    fill: "#f26222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M136.079,339.677c6.711-.214,6.71-9.944,0-10.157C129.368,329.734,129.369,339.465,136.079,339.677Z",
    transform: "translate(-23.408 -245.644)",
    fill: "#f26222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M112.671,434.849a7.89,7.89,0,0,0-7.583,5.739.866.866,0,0,0,.835,1.1h13.5a.877.877,0,0,0,.835-1.1,7.9,7.9,0,0,0-7.583-5.739Z",
    transform: "translate(0 -340.393)",
    fill: "#f26222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M472.719,339.677c6.711-.214,6.71-9.944,0-10.157C466.008,329.734,466.009,339.465,472.719,339.677Z",
    transform: "translate(-326.007 -245.644)",
    fill: "#f26222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M456.926,440.591a7.879,7.879,0,0,0-15.166,0,.877.877,0,0,0,.835,1.1h13.5a.867.867,0,0,0,.835-1.1Z",
    transform: "translate(-302.631 -340.396)",
    fill: "#f26222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M241.765,257.838a.87.87,0,0,0,.42-.109l9.563-5.295,9.569,5.295h0a.87.87,0,1,0,.843-1.522l-9.542-5.28v-9.609a.87.87,0,0,0-1.739,0v9.609l-9.536,5.279a.875.875,0,0,0,.422,1.631Z",
    transform: "translate(-122.06 -165.502)",
    fill: "#f26222"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCptl);
export default __webpack_public_path__ + "static/media/ic-cptl.8569a1f4.svg";
export { ForwardRef as ReactComponent };